import { ParentProps, createContext, onCleanup, onMount } from 'solid-js'
import { registerServerMessage, requireContext } from 'common'
import { visitorManagementListener as api } from 'st-app/api'
import { VisitorManagementListenerContext } from './VisitorManagementListenerContext'
import styles from './st-visitor-management-listener.module.css'

const VisitorManagementListenerContextJsx = createContext<VisitorManagementListenerContext>();
export const requireVisitorManagementListenerContext = () => {
    return requireContext(VisitorManagementListenerContextJsx);
}

export class VisitorManagementListenerProps { }

export default function VisitorManagementListener(props: ParentProps<VisitorManagementListenerProps>) {
    const context = new VisitorManagementListenerContext();

    return (
        <VisitorManagementListenerContextJsx.Provider value={context}>
            <VisitorManagementListenerInternal {...props} />
        </VisitorManagementListenerContextJsx.Provider>
    )
}

let userGU = '';

function VisitorManagementListenerInternal(props: ParentProps<VisitorManagementListenerProps>) {
    onMount(async () => {
        userGU = await api.StartListening();
        console.log('listening for visitor management events...');
    })

    onCleanup(async () => {
        await api.StopListening();
        console.log('stopping listener for visitor management events...');
    })

    return (
        <div class={styles['st-visitor-management-listener']}>
            {props.children}
        </div>
    );
}

VisitorManagementListener.defaultProps = new VisitorManagementListenerProps();

registerServerMessage('VisitorManagementRefreshMessage', (data: { ChangedByUserGU: string }) => {
    window.ST.RefreshViews('8A5CC858-0284-4E7A-B6F8-5F539DD9F07B')
});